import { Button, Container, Stack } from '@mui/material';
import { Box } from '@mui/system';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import ApplicationView from '../Global/ApplicationView';
import { getOfflineApplicationRes } from '../../store/Slice/Lead/LeadSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useLeadSelector from '../../store/Slice/Lead/LeadSelector';

function ProcessLogin() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { leadesItem } = location?.state || {};

  // console.log('leadesItemleadesItemleadesItem', leadesItem?.[0]?.logInStatusName);

  const { LoginData } = useLoginSelector();
  const { AppData } = useLeadSelector();
  const myData = structuredClone(AppData || {});

  const getApplicationByIdApi = useCallback(() => {
    const credential = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      applicationId: leadesItem[0]?.applicationId
    };
    dispatch(getOfflineApplicationRes(credential));
  }, [LoginData, leadesItem]);

  useEffect(() => {
    getApplicationByIdApi();
  }, [getApplicationByIdApi]);

  // ...........................

  return (
    <Page title="Partner Management System || Leads">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Post Recommendation" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <ApplicationView parent="login" offlineResponse={myData} />
        </Box>
      </Container>
    </Page>
  );
}
export default ProcessLogin;
